export default "__VITE_ASSET__DH1yReuR__"